import Pledge from './pledge'
import { reduxForm } from 'redux-form'
import { updateRemotely } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { formatMoney } from 'griffin'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/chip_in_glimpse/pledge')

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    currency: campaign.currency,
    maxAmount: campaign.max_amount,
    initialValues: {
      pledge: campaign.pledge || 0,
    },
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onPledge(fields) {
      return dispatch(
        updateRemotely(campaignId, { pledge: fields.pledge || 0 })
      )
    },
  }
}

function pledgeAmountValidator() {
  return (values, props) => {
    const amount = parseFloat(values.pledge)
    if (amount && props.maxAmount) {
      if (amount > props.maxAmount) {
        const formattedAmount = formatMoney(props.currency, props.maxAmount, {
          removeTrailingZeros: false,
        })
        const errorLabel = i18n('max_amount', { amount: formattedAmount })
        return { pledge: errorLabel }
      }
    }

    return {}
  }
}

export default reduxForm(
  {
    form: 'pledge',
    fields: ['pledge'],
    destroyOnUnmount: false,
    touchOnChange: false,
    touchOnBlur: true,
    validate: pledgeAmountValidator(),
  },
  mapStateToProps,
  mapDispatchToProps
)(Pledge)
